<div class="position-relative">
  <div #filterBtn (click)="setFilterModel()" class="filterBtn">
    <!-- <i class="fa fa-filter" aria-hidden="true"></i> -->
     <img src="/assets/images/filterIcon-shg.svg" class="img-fluid me-1" alt="Filter"/>
     FILTERS
  </div>

  <div #filterform (click)="$event.stopPropagation()" *ngIf="openFilterModel" class="card filter-form shadow custom_scroll">
    <div class="container mt-2 custom_scroll overflow-auto" style="max-height: 275px;">
      <form [formGroup]="filterForm" (ngSubmit)="submitForm()">
        <div *ngFor="let field of formFields" class="form-group row">
          <div class="col">
            <ng-container [ngSwitch]="field.type">
              <mat-form-field *ngSwitchCase="'select'" appearance="outline" class="example-full-width custom_select w-100 me-4">
                <mat-label>{{ field.label }} <span *ngIf="field.name === 'financialYear' || field.name === 'finYear'" class="text-danger">*</span></mat-label>
                <mat-select formControlName="{{ field.name }}"  (selectionChange)="selectedFormValue($event, field.name)" >
                  <mat-option value="">Select</mat-option>
                  <mat-option *ngFor="let option of field.options" [value]="option.value">{{ option.label }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field *ngSwitchCase="'text'" appearance="outline" class="example-full-width w-100 me-4 custom_Input">
                <mat-label>{{ field.label }}</mat-label>
                <input matInput type="text" formControlName="{{ field.name }}">
              </mat-form-field>

              <mat-form-field *ngSwitchCase="'number'" appearance="outline" class="example-full-width w-100 me-4">
                <mat-label>{{ field.label }}</mat-label>
                <input matInput type="number" formControlName="{{ field.name }}">
              </mat-form-field>

              <mat-form-field *ngSwitchCase="'date'" appearance="outline" class="example-full-width custom_date w-100 me-4">
                <mat-label>{{ field.label }}</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="{{ field.name }}"  (dateChange)="onFromDateChange($event)"  [max]="currentDate">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>

              <mat-form-field *ngSwitchCase="'toDate'" appearance="outline" class="example-full-width custom_date w-100 me-4">
                <mat-label>{{ field.label }}</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="{{ field.name }}" [min]="minToDate"  [max]="currentDate">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>

            </ng-container>
          </div>
        </div>

        <hr class="formHr">
        <div class="text-end mb-2">
          <button type="button" class="btn resetBtn" (click)="reset()">Reset</button>
          <button type="submit" class="btn applyBtn text-white">Apply</button>
        </div>
      </form>
    </div>
  </div>
</div>
